import React from "react";
import "./Footer.css";
import logo from "../../Images/dhanushdhari_final_log.jpeg"
import { FaMapMarkerAlt, FaPhone, FaFax, FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaInstagram, FaGooglePlusG, FaPinterest, FaRss } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">

        <div>
    <img src={logo} alt="Company Logo" className="footer-logo" />
        </div>
          
        

        <div className="footer-info">
          <p><FaMapMarkerAlt /> Hosue of Dhanushdhari</p>
          <p><FaPhone /> (123) 456-7890</p>
          <p><FaFax /> (123) 456-7890</p>

          <div className="footer-social">
            <span>Social Media</span>
            <div>
              <FaFacebookF />
              <FaTwitter />
              <FaLinkedinIn />
              <FaYoutube />
              <FaInstagram />
              <FaGooglePlusG />
              <FaPinterest />
              <FaRss />
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}